"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VALUE = exports.TYPE = void 0;
const id_1 = require("../../../utils/id");
const constants_1 = require("../../constants");
const types_1 = require("../../types");
exports.TYPE = 'testKeyboardInput';
exports.DEFAULT_VALUE = {
    items: [
        {
            label: '',
            points: 1,
            value: (0, id_1.generateId)(),
        },
    ],
    displayFeedback: true,
    displayOption: types_1.TestAnswerFeedbackDisplayOption.general,
    answerFeedback: true,
    generalFeedback: constants_1.feedbackValue,
    generalTypeFb: types_1.TestAnswerFeedbackType.validation,
};
